import { Box } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";
import { Text } from "#components/atoms/Typographies/Text";

type Props = {
  quantityInAssembly: number;
};

export const QuantityInAssemblyCell = ({ quantityInAssembly }: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: spacing[8],
        padding: `0 ${spacing[3]}`,
        border: `1px solid ${colors.border.quaternary}`,
        borderRadius: radius.xs,
        backgroundColor: colors.bg.elevation.primary,
      }}
    >
      <Text size="small">{quantityInAssembly}</Text>
      <Text size="small" color={colors.text.secondaryDefault}>
        {t("quoteRequestV2.assembly.perPieceSuffix")}
      </Text>
    </Box>
  );
};
